export default "__VITE_ASSET__Coh1JEOS__"